export interface GlossaryTerm {
  term: string;
  definition: string;
  url: string;
  category: string[];
  relatedTerms: string[];
  lastUpdated: string;
}

const glossaryTerms: GlossaryTerm[] = [
  // ... [Previous terms remain unchanged]
  {
    term: "Advertising Effectiveness",
    definition: "A comprehensive measure of how well advertising achieves its intended objectives, incorporating metrics like ROI, ROAS, engagement rates, and conversion rates. Used to evaluate and optimize advertising strategies.",
    url: "/glossary-term/advertising-effectiveness",
    category: ["Advertising", "Marketing Analytics"],
    relatedTerms: ["Advertising ROI", "ROAS", "Conversion Rate", "Ad Performance"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Average Revenue Per User (ARPU)",
    definition: "The mean revenue generated per user or customer over a specific time period. This metric helps businesses understand customer value and optimize monetization strategies.",
    url: "/glossary-term/average-revenue-per-user",
    category: ["Business Metrics", "Customer Analytics"],
    relatedTerms: ["Customer Lifetime Value", "Average Order Value", "Revenue Metrics"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Advertising Saturation",
    definition: "The point at which additional advertising exposure no longer produces proportional returns. Understanding this helps optimize ad frequency and budget allocation.",
    url: "/glossary-term/advertising-saturation",
    category: ["Advertising", "Media Planning"],
    relatedTerms: ["Ad Frequency", "Ad Burnout", "Media Planning"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Audience Value",
    definition: "The monetary or strategic worth of a specific audience segment, based on factors like purchasing power, engagement level, and conversion potential.",
    url: "/glossary-term/audience-value",
    category: ["Marketing Strategy", "Audience Analysis"],
    relatedTerms: ["Customer Value", "Segmentation", "Targeting"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Analytics Dashboard",
    definition: "A visual interface that displays key marketing metrics, KPIs, and performance data in an organized and easily digestible format. Essential for monitoring and analyzing marketing efforts.",
    url: "/glossary-term/analytics-dashboard",
    category: ["Analytics", "Reporting"],
    relatedTerms: ["KPIs", "Metrics", "Performance Monitoring"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Acquisition Channel",
    definition: "The various marketing channels and methods used to acquire new customers, such as paid advertising, organic search, social media, or email marketing.",
    url: "/glossary-term/acquisition-channel",
    category: ["Marketing Strategy", "Customer Acquisition"],
    relatedTerms: ["Customer Acquisition Cost", "Marketing Channels", "Lead Generation"],
    lastUpdated: "2024-10-23"
  },
  {
    term: "Advertising Mix",
    definition: "The combination of different advertising channels and formats used in a marketing campaign. Optimizing this mix is crucial for maximizing overall campaign effectiveness.",
    url: "/glossary-term/advertising-mix",
    category: ["Advertising", "Marketing Strategy"],
    relatedTerms: ["Media Planning", "Channel Strategy", "Campaign Planning"],
    lastUpdated: "2024-10-23"
  }
];

export default glossaryTerms;
